import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    // Aquí es donde almacenarás tus variables de estado
    //todos los usuarios
    users: [],
    //usuario logueado 
    userLogged: "",
    //Lista de nombres de usuarios
    usersList: [],
    // usuario autenticado
    userAuth: "",
    // nuevo usuario
    newuser:[],
    // id del nuevo usuario
    idnewuser: "",
    // id del nuevo tecnico
    idtecnico:"",
    newidtecnico:"",
    newdata:"",
    // autenticado?
    auth: false,
    // tipo de ususario
    userType: "",
    //empresas en la que trabaja el usuario
    userEmpresas:[],
    // usuario actual 
    currentUser: null,
    // todo la data de optix
    optixData: null,
    // nueva data optix
    optix: [],
    // todo la data de optix
    westnetData: null,
    // nueva data optix
    westnet: [],
    // todo la data de optix
    bigwayData: null,
    // nueva data optix
    bigway: [],
    
    totales:[],
    totalesList: [],
    tecnico:[],
    tecnicoList: [],
    precios:[],
    preciosget:"",
    //nombres de los tecnicos
    tecnicosName:[],
    //nombre de la collection que se guardara
    collection:"",
    //data de los objetos de los routers que se guardan en Equipos
    routers: [],
    // boolean para abrir y cerrar modales
    showModalFlag: false,
    selectedItem: {}
  },
  mutations: {
    // Aquí es donde escribirás tus funciones para cambiar el estado
    SET_USER_LOGGED(state, user) {
      state.userLogged = user;
    },
    SET_USERS(state, user) {
      state.users = user;
    },
    SET_USERAUTH(state, user) {
      state.userAuth = user;
    },
    SET_AUTH(state, user) {
      state.auth = user;
    },
    SET_USERTYPE(state, user) {
      state.userType = user;
    },
    SET_USEREMPRESAS(state, user) {
      state.userEmpresas = user;
    },
    SET_OPTIX(state, data) {
      state.optix.splice(0,1);
      state.optix.push(data)
    },
    SET_WESTNET(state, data) {
      state.westnet.splice(0,1);
      state.westnet.push(data)
    },
    SET_BIGWAY(state, data) {
      state.bigway.splice(0,1);
      state.bigway.push(data)
    },
    SET_NEWUSER(state, data) {
      state.newuser.splice(0,1);
      state.newuser.push(data)
    },
    SET_TECNICO(state, data) {
      state.tecnico.splice(0,1);
      state.tecnico.push(data)
    },
    SET_IDNEWUSER(state, user) {
      state.idnewuser = user;
    },
    SET_IDTECNICO(state,idTecnico) {
      state.newidtecnico = idTecnico.idtecnico;
    },
    SET_NEWDATA(state, data) {
      state.newdata = data;
    },
    SET_PRECIOS(state, data) {
      state.precios.splice(0,1);
      state.precios.push(data)
    },
    SET_COLLECTION(state, data) {
      state.collection = data;
    },
    SET_ROUTERS(state, data) {
      state.routers = data;
    },
    openModal(state, item) {
      state.showModalFlag = true
      state.selectedItem = item
    },
    closeModal(state) {
      state.showModalFlag = false
      state.selectedItem = {}
    }
  },

  // Aquí es donde escribirás tus acciones asíncronas
  actions: {
    setOptixData(context, data) {
      context.commit("SET_OPTIX", data);
    },
    setBigwayData(context, data) {
      context.commit("SET_BIGWAY", data);
    },
    setWestnetData(context, data) {
      context.commit("SET_WESTNET", data);
    },
    setNewUser(context, data) {
      context.commit("SET_NEWUSER", data);
    },
    setTecnico(context, data) {
      context.commit("SET_TECNICO", data);
    },
    setPrecios(context, data) {
      context.commit("SET_PRECIOS", data);
    },
    setIdTecnico(context, data) {
      context.commit("SET_IDTECNICO", data);
    },
    openModal({ commit }, item) {
      commit('openModal', item)
    },
    closeModal({ commit }) {
      commit('closeModal')
    }
  },

  getters: {
    // Aquí es donde escribirás tus funciones para obtener datos del estado
    showModalFlag: state => state.showModalFlag,
    selectedItem: state => state.selectedItem
  },
});
